<template>
  <div>
    <div class="table-wrap">
      <el-table size="small" :data="workerlist" border style="width: 100%">
        <el-table-column type="index" align="center" label="" width="60">
        </el-table-column>
        <el-table-column prop="waiterUser.username" align="center" label="技师姓名" width="100">
        </el-table-column>
        <el-table-column prop="" align="center" label="技师头像" width="100">
          <template slot-scope="scope">
            <el-image v-if="scope.row.waiterUser && scope.row.waiterUser.avatarUrl" style="width: 50px; height: 50px"
              fit="cover" :src="scope.row.waiterUser.avatarUrl" :preview-src-list="[scope.row.waiterUser.avatarUrl]">
            </el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="waiterUser.mobile" label="技师联系方式"  width="100">
        </el-table-column>
        <el-table-column align="center" prop="waiterUser.scale" label="技师总分" width="120">
        </el-table-column>
        <el-table-column align="center" prop="waiterUser.address" label="服务地址" width="220">
        </el-table-column>
        <el-table-column align="center" label="服务态度评分" width="100">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.describe_score == 1">服务好</span>
              <span v-else-if="scope.row.describe_score == 2">态度好</span>
              <span v-else>技术好</span>
            </div>
            <div>
              <span v-if="scope.row.score == 10">好评</span>
              <span v-else-if="scope.row.score == 20">中评</span>
              <span v-else>差评</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="content" align="center" label="评价内容" width="180">
        </el-table-column>
        <el-table-column prop="server_score" align="center" label="用户评分" width="100">
        </el-table-column>
        <el-table-column prop="" align="center" label="评价图片" >
          <template slot-scope="scope">
            <div class="item-all" style="display: flex; width: 100%;height: 100%;">
              <div class="item" v-for="(item, index) in scope.row.image" :key="index">
                <img :src="item.image_path" alt="" style="height: 50px;width: 100px;">
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="card_name" align="center" label="状态" width="120">
          <template slot-scope="scope">
			  <el-tag v-if="scope.row.status == 0" type="danger">待审核</el-tag>
			  <el-tag v-else-if="scope.row.status == 1" type="success">审核通过</el-tag>
			  <el-tag v-else type="danger">审核不通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
			  <el-button @click="navchange(scope.row)" type="primary" size="small" :disabled="scope.row.status != 0">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="getworker.page"
        :page-sizes="[10, 20, 30, 40]" :page-size="getworker.rows" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--审核-->
    <el-dialog title="审核" :visible.sync="dialogVisible" width="30%">
      <!-- <span>{{workerinfo}}</span>
        <span>{{radio}}</span> -->
      <el-form :model="workerinfo" :rules="rules" ref="formName">
        <el-form-item label="是否允许" prop="status	">
          <el-radio v-model="workerinfo.status" :label="1">审核通过</el-radio>
          <el-radio v-model="workerinfo.status" :label="2">审核不通过</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changestatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      radio: '1',
      rules: {
        status: [
          { required: true, message: '请选择！', trigger: 'blur' }
        ]
      },
      workerinfo: {
        status: 0,
      },
      dialogVisible: false,
      workerlist: [],
      getworker: {
        page: 1,
        rows: 10,
        status: 'all'
      },
      total: 0
    };
  },
  created() {

    /*获取列表*/
    this.getTableList()

  },
  mounted() {
    // console.log('1212', this.workerlist);
  },
  methods: {
    // 进入审核页面
    navchange(e) {
      this.workerinfo.comment_id = e.comment_id,
        this.workerinfo.status = e.status
      this.dialogVisible = true
    },
    // 修改审核状态
    changestatus() {
      let that = this
      if (this.workerinfo.status) {
        request._post('/shop/waiter.comment/replyComment', {
          comment_id: that.workerinfo.comment_id,
          status: that.workerinfo.status
        }).then(res => {
          if (res.code == 1) {
            that.$message({
              type: 'success',
              message: res.msg
            });
          }
          that.getTableList()
        })
      } else {
        console.log('选择', that.workerinfo);
      }

      this.dialogVisible = false
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.getworker.page = val
      this.getTableList()
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.getworker.rows = val
      this.getTableList()
    },

    /*获取列表*/
    getTableList() {
      let that = this;
      request._get('/shop/waiter.Comment/commentStatusList', this.getworker).then(res => {
        console.log(res, 121);
        this.workerlist = res.data.data
        this.total = res.data.total
      })

    }

  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/views/order/comment/index.vue